/**

 * Script exportado: Quiz de reforço (Microquiz) — feedback + tentativas via Moodle AJAX (Fase 2).

 * Tokens [[GEPPETTO_CMID]] e [[GEPPETTO_SESSKEY]] são substituídos no plugin ao servir o arquivo.

 */



export const GEPPETTO_MICROQUIZ_EXPORT_SCRIPT = `

<style>

  .geppetto-microquiz-trigger:disabled {

    opacity: 0.55;

    cursor: not-allowed !important;

  }

  .geppetto-microquiz-trigger.is-completed {

    box-shadow: inset 0 0 0 2px rgba(22, 163, 74, 0.35);

  }

  .geppetto-microquiz-trigger-check {

    display: inline-flex;

    align-items: center;

    justify-content: center;

    width: 22px;

    height: 22px;

    border-radius: 50%;

    background: #16a34a;

    color: #fff;

    font-size: 13px;

    font-weight: 700;

    flex-shrink: 0;

    line-height: 1;

  }

  .geppetto-microquiz-completed-hint {

    font-size: 13px;

    margin-top: 6px;

    line-height: 1.45;

    color: #15803d;

  }

  .geppetto-microquiz-completed-hint.is-below-pass {

    color: #b45309;

  }

  .geppetto-microquiz-summary-badge {

    display: inline-flex;

    align-items: center;

    gap: 8px;

    padding: 6px 12px;

    border-radius: 999px;

    background: #f0fdf4;

    color: #166534;

    font-size: 13px;

    font-weight: 600;

    margin-bottom: 12px;

  }

  .geppetto-microquiz-option {

    display: block;

    width: 100%;

    text-align: left;

    padding: 12px 14px;

    margin-bottom: 8px;

    border: 1px solid #e2e8f0;

    border-radius: 8px;

    background: #fff;

    cursor: pointer;

    font-size: 15px;

    color: #1e293b;

    transition: border-color 0.15s, background 0.15s;

  }

  .geppetto-microquiz-option:hover:not(:disabled) {

    border-color: #3b82f6;

    background: #f8fafc;

  }

  .geppetto-microquiz-option.is-correct {

    border-color: #16a34a;

    background: #f0fdf4;

  }

  .geppetto-microquiz-option.is-wrong {

    border-color: #dc2626;

    background: #fef2f2;

  }

  .geppetto-microquiz-feedback {

    margin-top: 12px;

    padding: 12px;

    border-radius: 8px;

    font-size: 14px;

    line-height: 1.5;

  }

  .geppetto-microquiz-feedback.ok { background: #f0fdf4; color: #166534; }

  .geppetto-microquiz-feedback.bad { background: #fef2f2; color: #991b1b; }

  .geppetto-microquiz-nav {

    display: flex;

    justify-content: flex-end;

    gap: 8px;

    margin-top: 16px;

    flex-shrink: 0;

  }

  .geppetto-microquiz-nav button {

    padding: 8px 16px;

    border-radius: 6px;

    font-weight: 600;

    font-size: 14px;

    cursor: pointer;

    border: none;

  }

  .geppetto-microquiz-btn-primary { background: #3b82f6; color: #fff; }

  .geppetto-microquiz-locked-hint {

    font-size: 13px;

    color: #64748b;

    margin-top: 6px;

  }

  .geppetto-microquiz-result-score {

    font-size: 1.5rem;

    font-weight: 700;

    color: #1e293b;

    margin: 8px 0 4px;

  }

</style>

<script>

(function() {

  if (window.__geppettoMicroquizInit) return;

  window.__geppettoMicroquizInit = true;

  var quizStateById = {};

  var premiumOk = true;

  var moodleCtx = null;

  var quizStateLoaded = false;

  var activityGradeMax = 0;

  var moduleGradePercent = -1;



  function getPassingScore(cfg) {

    var n = parseInt(cfg && cfg.passingScorePercent, 10);

    return isNaN(n) ? 70 : Math.min(100, Math.max(0, n));

  }



  function buildFeedbackConfig(manifest, server) {

    return {

      attemptPolicy: (server && server.attemptpolicy) || (manifest && manifest.attemptPolicy) || 'best_unlimited',

      maxAttempts: (server && server.maxattempts) || (manifest && manifest.maxAttempts) || 3,

      showFeedbackFromAttempt: (server && server.showfeedbackfromattempt != null) ? server.showfeedbackfromattempt : ((manifest && manifest.showFeedbackFromAttempt != null) ? manifest.showFeedbackFromAttempt : 0),

      passingScorePercent: (server && server.passingscorepercent) || (manifest && manifest.passingScorePercent) || 70,

      showFeedbackOnPass: server ? server.showfeedbackonpass !== false : (manifest ? manifest.showFeedbackOnPass !== false : true),

      graded: !!(manifest && manifest.graded)

    };

  }



  function shouldShowDetailedFeedback(cfg, attemptNum, scorePercent) {

    var passing = getPassingScore(cfg);

    var showOnPass = cfg.showFeedbackOnPass !== false;

    if (showOnPass && typeof scorePercent === 'number' && scorePercent >= passing) {

      return true;

    }

    var attempt = Math.max(1, parseInt(attemptNum, 10) || 1);

    var policy = cfg.attemptPolicy || 'best_unlimited';

    if (policy === 'best_limited') {

      var max = Math.max(1, parseInt(cfg.maxAttempts, 10) || 3);

      return attempt >= max;

    }

    if (policy === 'single') {

      return attempt >= 1;

    }

    var from = parseInt(cfg.showFeedbackFromAttempt, 10);

    if (!isFinite(from) || from <= 0) {

      return false;

    }

    return attempt >= from;

  }



  function feedbackHiddenHint(cfg) {

    var policy = cfg.attemptPolicy || 'best_unlimited';

    if (policy === 'best_limited' || policy === 'single') {

      return 'O gabarito detalhado será exibido na última tentativa.';

    }

    var n = Math.max(0, parseInt(cfg.showFeedbackFromAttempt, 10) || 0);

    if (n <= 0) {

      return 'O gabarito não será exibido durante as tentativas. Defina a partir de qual tentativa liberar ou use a nota mínima.';

    }

    return 'O gabarito detalhado será exibido a partir da ' + n + 'ª tentativa.';

  }



  function resolveMoodleContext() {

    if (moodleCtx) return moodleCtx;

    var cmid = '';

    var sk = '';

    var wwwroot = '';

    if (window.geppettoMoodleCmid) {

      cmid = String(window.geppettoMoodleCmid);

    }

    if (window.geppettoMoodleSesskey) {

      sk = String(window.geppettoMoodleSesskey);

    }

    if (window.geppettoMoodleWwwroot) {

      wwwroot = String(window.geppettoMoodleWwwroot).replace(/\\/$/, '');

    }

    if (!cmid || !sk) {

      var wrap = document.querySelector('.geppetto-microquiz-wrap[data-gep-cmid]');

      if (wrap) {

        cmid = String(wrap.getAttribute('data-gep-cmid') || '');

        sk = String(wrap.getAttribute('data-gep-sesskey') || '');

      }

    }

    if (!cmid || !sk) {

      var ck = document.querySelector('[data-gep-cmid]');

      if (ck) {

        cmid = String(ck.getAttribute('data-gep-cmid') || '');

        sk = String(ck.getAttribute('data-gep-sesskey') || '');

      }

    }

    moodleCtx = { cmid: cmid, sk: sk, wwwroot: wwwroot };

    return moodleCtx;

  }



  function isMoodleLive() {

    var ctx = resolveMoodleContext();

    if (!ctx.cmid || !ctx.sk) return false;

    if (ctx.cmid.indexOf('[') !== -1 || ctx.sk.indexOf('[') !== -1) return false;

    return parseInt(ctx.cmid, 10) > 0;

  }



  function moodleAjax(method, args) {

    var ctx = resolveMoodleContext();

    var base = ctx.wwwroot || location.origin;

    var u = base + '/lib/ajax/service.php?sesskey=' + encodeURIComponent(ctx.sk);

    return fetch(u, {

      method: 'POST',

      credentials: 'same-origin',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify([{ index: 0, methodname: method, args: args }])

    })

      .then(function(r) { return r.json(); })

      .then(function(d) {

        if (!d || !d[0]) throw new Error('net');

        if (d[0].error) {

          var ex = d[0].exception || {};

          throw new Error(ex.message || d[0].errorcode || 'err');

        }

        return d[0].data;

      });

  }



  function loadQuizStates() {

    if (!isMoodleLive()) return Promise.resolve();

    quizStateLoaded = false;

    var ctx = resolveMoodleContext();

    return moodleAjax('mod_gepettoresource_get_quiz_state', { cmid: parseInt(ctx.cmid, 10) })

      .then(function(data) {

        quizStateById = {};

        premiumOk = data.premiumok !== false;

        activityGradeMax = parseInt(data.activitygrademax, 10) || 0;

        moduleGradePercent = (data.modulegradepercent != null && parseFloat(data.modulegradepercent) >= 0)

          ? parseFloat(data.modulegradepercent) : -1;

        var list = (data && data.quizzes) ? data.quizzes : [];

        for (var i = 0; i < list.length; i++) {

          if (list[i] && list[i].quizid) quizStateById[list[i].quizid] = list[i];

        }

        refreshTriggerStates();

      })

      .catch(function() { quizStateLoaded = true; refreshTriggerStates(); })

      .then(function() { quizStateLoaded = true; });

  }



  function loadCkDone() {

    try {

      if (window.__geppettoCkProgress && typeof window.__geppettoCkProgress.getDone === 'function') {

        return window.__geppettoCkProgress.getDone();

      }

    } catch (e) {}

    return [];

  }



  function hydrateCkProgressFromServer() {

    if (!isMoodleLive()) return Promise.resolve();

    var ctx = resolveMoodleContext();

    var base = ctx.wwwroot || location.origin;

    var u = base + '/lib/ajax/service.php?sesskey=' + encodeURIComponent(ctx.sk);

    return fetch(u, {

      method: 'POST',

      credentials: 'same-origin',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify([{ index: 0, methodname: 'mod_gepettoresource_get_progress', args: { cmid: parseInt(ctx.cmid, 10) } }])

    })

      .then(function(r) { return r.json(); })

      .then(function(d) {

        if (!d || !d[0] || d[0].error) return;

        var payload = d[0].data;

        if (payload && Array.isArray(payload.done) && window.__geppettoCkProgress

            && typeof window.__geppettoCkProgress.mergeDone === 'function') {

          window.__geppettoCkProgress.mergeDone(payload.done);

        }

        return loadQuizStates();

      })

      .catch(function() {});

  }



  function ckIndexForWidgetId(ckWidgetId) {

    var ids = null;

    try {

      if (window.__geppettoCkProgress && Array.isArray(window.__geppettoCkProgress.ckIds)) {

        ids = window.__geppettoCkProgress.ckIds;

      }

    } catch (e) {}

    if (!ids && typeof ckIds !== 'undefined' && Array.isArray(ckIds)) ids = ckIds;

    if (!ckWidgetId || !ids) return -1;

    return ids.indexOf(ckWidgetId);

  }



  function findQuizWrap(widgetId) {

    if (!widgetId) return null;

    return document.querySelector('.geppetto-microquiz-wrap[data-quiz-id="' + widgetId + '"]');

  }



  function resolveRequiresCk(wrap, manifest) {

    var fromWrap = wrap ? (wrap.getAttribute('data-requires-ck') || '') : '';

    if (fromWrap) return fromWrap;

    if (manifest && manifest.requiresCheckpointId) return String(manifest.requiresCheckpointId);

    return '';

  }



  function resolveCkLabel(wrap, manifest) {

    var fromWrap = wrap ? (wrap.getAttribute('data-requires-ck-label') || '') : '';

    if (fromWrap) return fromWrap;

    if (manifest && manifest.requiresCheckpointLabel) return String(manifest.requiresCheckpointLabel);

    return '';

  }



  function syncWrapCheckpointAttrs(wrap, manifest) {

    if (!manifest || !wrap) return;

    if (!wrap.getAttribute('data-requires-ck') && manifest.requiresCheckpointId) {

      wrap.setAttribute('data-requires-ck', String(manifest.requiresCheckpointId));

    }

    if (!wrap.getAttribute('data-requires-ck-label') && manifest.requiresCheckpointLabel) {

      wrap.setAttribute('data-requires-ck-label', String(manifest.requiresCheckpointLabel));

    }

    if (!wrap.getAttribute('data-requires-ck-index') && manifest.requiresCheckpointIndex != null) {

      wrap.setAttribute('data-requires-ck-index', String(manifest.requiresCheckpointIndex));

    }

  }



  function resolveRequiresCkIndex(wrap, manifest, requiresCkId) {

    var fromWrap = wrap ? wrap.getAttribute('data-requires-ck-index') : '';

    if (fromWrap !== '' && fromWrap != null) {

      var parsed = parseInt(fromWrap, 10);

      if (!isNaN(parsed)) return parsed;

    }

    if (manifest && manifest.requiresCheckpointIndex != null) {

      var fromManifest = parseInt(manifest.requiresCheckpointIndex, 10);

      if (!isNaN(fromManifest)) return fromManifest;

    }

    if (requiresCkId) return ckIndexForWidgetId(requiresCkId);

    return -1;

  }



  function isQuizCheckpointBlocked(widgetId, wrap, manifest) {

    if (!wrap) wrap = findQuizWrap(widgetId);

    syncWrapCheckpointAttrs(wrap, manifest);

    var requiresCk = resolveRequiresCk(wrap, manifest);

    if (!requiresCk) {

      var serverNoCk = quizStateById[widgetId];

      return !!(quizStateLoaded && serverNoCk && serverNoCk.canopen === false);

    }

    return !isCheckpointSatisfied(widgetId, requiresCk, wrap, manifest);

  }



  function isCheckpointSatisfied(widgetId, requiresCkId, wrap, manifest) {

    if (!requiresCkId) return true;

    if (!wrap) wrap = findQuizWrap(widgetId);

    var idx = resolveRequiresCkIndex(wrap, manifest, requiresCkId);

    if (idx >= 0 && loadCkDone().indexOf(idx) !== -1) return true;

    var server = quizStateById[widgetId];

    if (isMoodleLive() && quizStateLoaded) {

      if (server && typeof server.canopen === 'boolean') return server.canopen;

      return false;

    }

    if (idx < 0) return false;

    if (server && typeof server.canopen === 'boolean') return server.canopen;

    return false;

  }



  function readQuizDef(widgetId) {

    var el = document.querySelector('script.geppetto-microquiz-def[data-quiz-id="' + widgetId + '"]');

    if (!el) return null;

    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }

  }



  function getManifestEntry(widgetId) {

    if (typeof quizManifest === 'undefined' || !Array.isArray(quizManifest)) return null;

    for (var i = 0; i < quizManifest.length; i++) {

      if (quizManifest[i] && quizManifest[i].id === widgetId) return quizManifest[i];

    }

    return null;

  }



  function storageKey(widgetId) {

    var cm = resolveMoodleContext().cmid || '0';

    return 'geppetto_mq_' + widgetId + '_cm_' + cm;

  }



  function loadAttemptsLocal(widgetId) {

    try {

      var raw = localStorage.getItem(storageKey(widgetId));

      if (!raw) return [];

      var p = JSON.parse(raw);

      return Array.isArray(p) ? p : [];

    } catch (e) { return []; }

  }



  function saveAttemptLocal(widgetId, scorePercent) {

    var list = loadAttemptsLocal(widgetId);

    list.push({ scorePercent: scorePercent, time: Date.now() });

    try { localStorage.setItem(storageKey(widgetId), JSON.stringify(list)); } catch (e) {}

  }



  function canAttemptMoreLocal(widgetId, manifest) {

    if (!manifest) return true;

    var policy = manifest.attemptPolicy || 'best_unlimited';

    var attempts = loadAttemptsLocal(widgetId);

    if (policy === 'single') return attempts.length < 1;

    if (policy === 'best_limited') {

      var max = Math.max(1, parseInt(manifest.maxAttempts, 10) || 3);

      return attempts.length < max;

    }

    return true;

  }



  function canAttemptMore(widgetId, manifest, opts) {

    opts = opts || {};

    var server = quizStateById[widgetId];

    var localOk = canAttemptMoreLocal(widgetId, manifest);

    // Servidor une checkpoint + tentativas em canattempt; se o checkpoint já foi concluído localmente,
    // não deixar canopen:false stale bloquear o botão — usar só a política local de tentativas.
    if (opts.localCheckpointDone && server && server.canopen === false && server.canattempt === false) {

      return localOk;

    }

    if (server && typeof server.canattempt === 'boolean') return server.canattempt;

    return localOk;

  }



  function getAttemptCount(widgetId) {

    var server = quizStateById[widgetId];

    if (server && server.attemptcount != null) return parseInt(server.attemptcount, 10) || 0;

    return loadAttemptsLocal(widgetId).length;

  }



  function getBestScorePercent(widgetId) {

    var server = quizStateById[widgetId];

    if (server && getAttemptCount(widgetId) > 0) return parseInt(server.bestscore, 10) || 0;

    var local = loadAttemptsLocal(widgetId);

    var best = 0;

    for (var i = 0; i < local.length; i++) {

      best = Math.max(best, parseInt(local[i].scorePercent, 10) || 0);

    }

    return best;

  }



  function hasCompletedQuiz(widgetId) {

    return getAttemptCount(widgetId) > 0;

  }



  function formatQuizScoreSummary(widgetId, manifest) {

    var best = getBestScorePercent(widgetId);

    var cfg = buildFeedbackConfig(manifest, quizStateById[widgetId] || null);

    var passing = getPassingScore(cfg);

    var passed = best >= passing;

    if (cfg.graded && activityGradeMax > 0) {

      var pct = moduleGradePercent >= 0 ? moduleGradePercent : best;

      var raw = Math.round(activityGradeMax * pct / 100);

      var passRaw = Math.round(activityGradeMax * passing / 100);

      return {

        main: 'Você conseguiu ' + raw + ' de ' + activityGradeMax + ' desejados na atividade.',

        sub: 'Neste quiz: ' + best + '% · mínimo para aprovação: ' + passRaw + ' de ' + activityGradeMax,

        passed: passed,

        best: best,

        raw: raw,

        desired: activityGradeMax

      };

    }

    return {

      main: 'Você tirou ' + best + '% — meta: ' + passing + '%',

      sub: passed ? 'Parabéns, você atingiu a meta deste quiz!' : 'Revise o conteúdo e tente novamente quando quiser.',

      passed: passed,

      best: best,

      raw: best,

      desired: passing

    };

  }



  function renderQuizSummaryScreen(body, widgetId, manifest, onStartNewAttempt) {

    var summary = formatQuizScoreSummary(widgetId, manifest);

    var server = quizStateById[widgetId] || null;

    var canRetry = canAttemptMore(widgetId, manifest, { localCheckpointDone: true });

    var attemptCount = getAttemptCount(widgetId);

    var html = '<div class="geppetto-microquiz-summary">';

    html += '<div class="geppetto-microquiz-summary-badge">✓ Quiz já realizado</div>';

    html += '<div class="geppetto-microquiz-result-score">' + summary.best + '%</div>';

    html += '<p style="color:#475569;margin:0 0 8px;line-height:1.5;font-size:15px">' + summary.main + '</p>';

    html += '<p style="color:#64748b;margin:0 0 16px;font-size:14px;line-height:1.5">' + summary.sub + '</p>';

    if (attemptCount > 0) {

      html += '<p style="font-size:13px;color:#94a3b8;margin:0 0 16px;line-height:1.5">Tentativas realizadas: ' + attemptCount;

      if (server && server.attemptpolicy === 'best_limited' && server.attemptsremaining >= 0) {

        html += ' · restantes: ' + server.attemptsremaining;

      }

      html += '</p>';

    }

    if (canRetry) {

      html += '<div class="geppetto-microquiz-nav" style="justify-content:flex-start;margin-top:0">';

      html += '<button type="button" class="geppetto-microquiz-btn-primary geppetto-microquiz-retry-btn">Fazer nova tentativa</button>';

      html += '</div>';

    } else if (attemptCount > 0) {

      html += '<p style="font-size:13px;color:#64748b;margin:0;line-height:1.5">Você usou todas as tentativas disponíveis para este quiz.</p>';

    }

    html += '</div>';

    body.innerHTML = html;

    var retryBtn = body.querySelector('.geppetto-microquiz-retry-btn');

    if (retryBtn && typeof onStartNewAttempt === 'function') {

      retryBtn.addEventListener('click', onStartNewAttempt);

    }

  }



  function closeModal(modal) {

    if (!modal) return;

    modal.style.display = 'none';

    var panel = modal.querySelector('.geppetto-microquiz-panel');

    if (panel) {

      panel.style.position = '';

      panel.style.top = '';

      panel.style.left = '';

      panel.style.transform = '';

      panel.style.margin = '';

    }

  }



  function openModal(modal, trigger, widgetId) {

    if (!modal) return;

    if (widgetId) {

      try { modal.setAttribute('data-quiz-id', String(widgetId)); } catch (eAttr) {}

    }

    if (trigger && typeof trigger.scrollIntoView === 'function') {

      try { trigger.scrollIntoView({ block: 'center', behavior: 'instant' }); } catch (e1) {

        try { trigger.scrollIntoView(true); } catch (e2) {}

      }

    }

    if (modal.parentNode !== document.body) {

      try { document.body.appendChild(modal); } catch (e) {}

    }

    modal.style.display = 'flex';

    modal.style.position = 'fixed';

    modal.style.inset = '0';

    modal.style.zIndex = '100001';

    var panel = modal.querySelector('.geppetto-microquiz-panel');

    if (panel && trigger) {

      var rect = trigger.getBoundingClientRect();

      var panelH = Math.min(panel.offsetHeight || 420, window.innerHeight * 0.85);

      var top = rect.bottom + 12;

      if (top + panelH > window.innerHeight - 16) {

        top = Math.max(16, rect.top - panelH - 12);

      }

      panel.style.position = 'fixed';

      panel.style.top = top + 'px';

      panel.style.left = '50%';

      panel.style.transform = 'translateX(-50%)';

      panel.style.margin = '0';

    } else if (panel) {

      panel.style.position = '';

      panel.style.top = '';

      panel.style.left = '';

      panel.style.transform = '';

    }

  }



  function renderQuestion(body, def, qIndex, answers, onPick) {

    var q = def.questions[qIndex];

    if (!q) return;

    var html = '<p style="font-weight:600;color:#1e293b;margin:0 0 12px;line-height:1.45">' + String(q.prompt || '').replace(/</g,'&lt;') + '</p>';

    html += '<div class="geppetto-microquiz-options">';

    var opts = q.options || [];

    for (var oi = 0; oi < opts.length; oi++) {

      html += '<button type="button" class="geppetto-microquiz-option" data-opt="' + oi + '">' + String(opts[oi]).replace(/</g,'&lt;') + '</button>';

    }

    html += '</div>';

    html += '<div class="geppetto-microquiz-q-feedback"></div>';

    body.innerHTML = html;

    var optsEl = body.querySelectorAll('.geppetto-microquiz-option');

    for (var j = 0; j < optsEl.length; j++) {

      optsEl[j].addEventListener('click', function() {

        var picked = parseInt(this.getAttribute('data-opt'), 10);

        if (answers[qIndex] !== undefined) return;

        onPick(picked);

      });

    }

  }



  function renderResultsHtml(scorePercent, feedback, cfg, def, moduleGradePercent, bestScorePercent, showDetailed) {

    var total = def.questions.length;

    var passing = getPassingScore(cfg);

    var html = '';

    if (showDetailed) {

      var correct = 0;

      for (var i = 0; i < (feedback || []).length; i++) {

        if (feedback[i] && feedback[i].correct) correct++;

      }

      html = '<div class="geppetto-microquiz-result-score">' + correct + ' / ' + total + ' (' + scorePercent + '%)</div>';

    } else {

      html = '<div class="geppetto-microquiz-result-score">' + scorePercent + '%</div>';

    }

    if (def && def.widgetId) {

      var manifestEntry = getManifestEntry(def.widgetId);

      if (manifestEntry) {

        var scoreLine = formatQuizScoreSummary(def.widgetId, manifestEntry);

        html += '<p style="color:#475569;margin:0 0 12px;line-height:1.5;font-size:15px">' + scoreLine.main + '</p>';

      }

    }

    html += '<p style="color:#475569;margin:0 0 12px;line-height:1.5">';

    html += scorePercent >= passing ? 'Ótimo trabalho! Continue o módulo.' : 'Revise o conteúdo e tente novamente quando quiser.';

    html += '</p>';

    if (!showDetailed) {

      html += '<p style="color:#64748b;margin:0 0 8px;line-height:1.5">Sua melhor tentativa: <strong>' + (typeof bestScorePercent === 'number' ? bestScorePercent : scorePercent) + '%</strong></p>';

      html += '<p style="font-size:13px;color:#94a3b8;margin:0;line-height:1.5">' + feedbackHiddenHint(cfg) + '</p>';

      return html;

    }

    if (cfg && cfg.graded && isMoodleLive()) {

      if (typeof moduleGradePercent === 'number' && moduleGradePercent >= 0) {

        html += '<p style="font-size:13px;color:#64748b;margin:0">Nota do módulo (média ponderada): <strong>' + Math.round(moduleGradePercent) + '%</strong></p>';

      } else {

        html += '<p style="font-size:13px;color:#64748b;margin:0">Tentativa registrada no Moodle.</p>';

      }

    }

    html += '<div style="margin-top:12px">';

    for (var ri = 0; ri < (feedback || []).length; ri++) {

      var fb = feedback[ri];

      var ok = !!fb.correct;

      html += '<div class="geppetto-microquiz-feedback ' + (ok ? 'ok' : 'bad') + '" style="margin-bottom:8px">';

      html += '<strong>' + String(fb.prompt || '').replace(/</g,'&lt;') + '</strong><br/>';

      if (fb.explanation) html += String(fb.explanation).replace(/</g,'&lt;');

      html += '</div>';

    }

    html += '</div>';

    return html;

  }



  function clientGrade(def, answers) {

    var feedback = [];

    var correct = 0;

    var total = def.questions.length;

    for (var i = 0; i < total; i++) {

      var q = def.questions[i];

      var selected = answers[i] ?? -1;

      var expected = q.correctIndex ?? 0;

      var ok = selected === expected;

      if (ok) correct++;

      feedback.push({

        questionId: q.id,

        correct: ok,

        correctIndex: expected,

        selectedIndex: selected,

        explanation: q.explanation || '',

        prompt: q.prompt || ''

      });

    }

    return {

      scorePercent: total > 0 ? Math.round((correct / total) * 100) : 0,

      feedback: feedback

    };

  }



  function showResults(body, def, answers, manifest, attemptNum) {

    var responses = [];

    for (var i = 0; i < def.questions.length; i++) {

      var q = def.questions[i];

      responses.push({

        questionId: q.id || ('q' + i),

        selectedIndex: answers[i] ?? -1

      });

    }

    var server = quizStateById[def.widgetId] || null;

    var cfg = buildFeedbackConfig(manifest, server);

    var currentAttempt = Math.max(1, parseInt(attemptNum, 10) || 1);



    if (isMoodleLive()) {

      body.innerHTML = '<p style="color:#64748b">Enviando tentativa…</p>';

      var ctx = resolveMoodleContext();

      moodleAjax('mod_gepettoresource_submit_quiz_attempt', {

        cmid: parseInt(ctx.cmid, 10),

        quizid: def.widgetId,

        responses: JSON.stringify(responses)

      })

        .then(function(data) {

          quizStateById[def.widgetId] = Object.assign({}, quizStateById[def.widgetId] || {}, {

            attemptcount: data.attemptnum,

            bestscore: data.bestscorepercent,

            canattempt: data.canretry,

            attemptsremaining: data.attemptsremaining

          });

          if (typeof data.modulegradepercent === 'number' && data.modulegradepercent >= 0) {

            moduleGradePercent = parseFloat(data.modulegradepercent);

          }

          var showDetailed = data.showdetailedfeedback === true;

          body.innerHTML = renderResultsHtml(

            data.scorepercent,

            data.feedback,

            cfg,

            def,

            data.modulegradepercent,

            data.bestscorepercent,

            showDetailed

          );

          refreshTriggerStates();

        })

        .catch(function(err) {

          var msg = String(err.message || 'erro').replace(/</g, '&lt;');

          var isCheckpoint = /checkpoint/i.test(msg);

          body.innerHTML = '<div class="geppetto-microquiz-feedback bad">'

            + (isCheckpoint ? msg : ('Não foi possível registrar a tentativa: ' + msg))

            + '</div>';

        });

      return;

    }



    var graded = clientGrade(def, answers);

    saveAttemptLocal(def.widgetId, graded.scorePercent);

    var localAttempts = loadAttemptsLocal(def.widgetId);

    var bestLocal = 0;

    for (var li = 0; li < localAttempts.length; li++) {

      bestLocal = Math.max(bestLocal, parseInt(localAttempts[li].scorePercent, 10) || 0);

    }

    var showDetailedLocal = shouldShowDetailedFeedback(cfg, currentAttempt, graded.scorePercent);

    body.innerHTML = renderResultsHtml(

      graded.scorePercent,

      graded.feedback,

      cfg,

      def,

      -1,

      bestLocal,

      showDetailedLocal

    );

    refreshTriggerStates();

  }



  function startQuiz(widgetId, modal) {

    var def = readQuizDef(widgetId);

    if (!def || !def.questions || !def.questions.length) {

      var bodyEmpty = modal ? modal.querySelector('.geppetto-microquiz-body') : null;

      if (bodyEmpty) {

        bodyEmpty.innerHTML = '<div class="geppetto-microquiz-feedback bad">Nenhuma pergunta configurada neste quiz.</div>';

      }

      return;

    }

    var wrap = findQuizWrap(widgetId);

    var manifest = getManifestEntry(widgetId);

    if (isQuizCheckpointBlocked(widgetId, wrap, manifest)) {

      var bodyGuard = modal.querySelector('.geppetto-microquiz-body');

      if (bodyGuard) {

        bodyGuard.innerHTML = '<div class="geppetto-microquiz-feedback bad">Conclua o checkpoint do trecho antes de fazer este quiz.</div>';

      }

      refreshTriggerStates();

      return;

    }

    def.widgetId = widgetId;

    var body = modal.querySelector('.geppetto-microquiz-body');

    if (!body) return;

    var server = quizStateById[widgetId] || null;

    var cfg = buildFeedbackConfig(manifest, server);

    var priorAttempts = getAttemptCount(widgetId);

    var currentAttempt = priorAttempts + 1;

    var showDuringAttempt = shouldShowDetailedFeedback(cfg, currentAttempt, null);



    if (manifest && manifest.graded && isMoodleLive() && !premiumOk) {

      body.innerHTML = '<div class="geppetto-microquiz-feedback bad" style="margin:0">Recurso premium — atualize seu plano Geppetto para usar quizzes com nota neste módulo.</div>';

      return;

    }



    function beginQuizQuestions() {

      var answers = {};

      var qIndex = 0;



      function goNext() {

        qIndex++;

        if (qIndex >= def.questions.length) {

          showResults(body, def, answers, manifest, currentAttempt);

          return;

        }

        renderQuestion(body, def, qIndex, answers, onPick);

      }



      function onPick(picked) {

        answers[qIndex] = picked;

        var q = def.questions[qIndex];

        var ok = picked === (q.correctIndex ?? 0);

        var fb = body.querySelector('.geppetto-microquiz-q-feedback');

        if (fb) {

          fb.className = 'geppetto-microquiz-feedback ' + (showDuringAttempt && ok ? 'ok' : (showDuringAttempt && !ok ? 'bad' : ''));

          fb.style.background = showDuringAttempt ? '' : '#f8fafc';

          fb.style.color = showDuringAttempt ? '' : '#475569';

          fb.textContent = showDuringAttempt

            ? (q.explanation || (ok ? 'Correto!' : 'Resposta incorreta.'))

            : 'Resposta registrada.';

        }

        var optsEl = body.querySelectorAll('.geppetto-microquiz-option');

        for (var k = 0; k < optsEl.length; k++) {

          optsEl[k].disabled = true;

          var isCorrectOpt = k === (q.correctIndex ?? 0);

          if (showDuringAttempt && ok && k === picked) {

            optsEl[k].classList.add('is-correct');

          } else if (showDuringAttempt && !ok && k === picked) {

            optsEl[k].classList.add('is-wrong');

          } else if (showDuringAttempt && !ok && isCorrectOpt) {

            optsEl[k].classList.add('is-correct');

          } else if (!showDuringAttempt && k === picked && !ok) {

            optsEl[k].classList.add('is-wrong');

          } else if (!showDuringAttempt && k === picked && ok) {

            optsEl[k].classList.add('is-correct');

          }

        }

        var nav = document.createElement('div');

        nav.className = 'geppetto-microquiz-nav';

        var btn = document.createElement('button');

        btn.type = 'button';

        btn.className = 'geppetto-microquiz-btn-primary';

        btn.textContent = qIndex >= def.questions.length - 1 ? 'Ver resultado' : 'Próxima';

        btn.addEventListener('click', goNext);

        nav.appendChild(btn);

        body.appendChild(nav);

      }



      renderQuestion(body, def, qIndex, answers, onPick);

    }



    if (priorAttempts > 0) {

      renderQuizSummaryScreen(body, widgetId, manifest, beginQuizQuestions);

      return;

    }



    beginQuizQuestions();

  }



  function refreshTriggerStates() {

    var wraps = document.querySelectorAll('.geppetto-microquiz-wrap');

    for (var i = 0; i < wraps.length; i++) {

      var wrap = wraps[i];

      var widgetId = wrap.getAttribute('data-quiz-id');

      var btn = wrap.querySelector('.geppetto-microquiz-trigger');

      if (!btn) continue;

      var manifest = getManifestEntry(widgetId);

      syncWrapCheckpointAttrs(wrap, manifest);

      var requiresCk = resolveRequiresCk(wrap, manifest);

      var ckLabel = resolveCkLabel(wrap, manifest);

      var ckBlocked = isQuizCheckpointBlocked(widgetId, wrap, manifest);

      var localCkDone = !!requiresCk && !ckBlocked;

      var attemptsExhausted = !canAttemptMore(widgetId, manifest, { localCheckpointDone: localCkDone });

      var waitingServer = isMoodleLive() && !quizStateLoaded;

      btn.disabled = waitingServer || ckBlocked || attemptsExhausted;

      if (!btn.dataset.originalLabel) {

        btn.dataset.originalLabel = (btn.textContent || '').trim();

      }

      var completed = !waitingServer && !ckBlocked && hasCompletedQuiz(widgetId);

      if (completed) {

        btn.classList.add('is-completed');

        btn.innerHTML = '<span class="geppetto-microquiz-trigger-check" aria-hidden="true">✓</span>'

          + '<span class="geppetto-microquiz-trigger-text">' + btn.dataset.originalLabel + '</span>';

      } else {

        btn.classList.remove('is-completed');

        btn.textContent = btn.dataset.originalLabel;

      }

      var completedHint = wrap.querySelector('.geppetto-microquiz-completed-hint');

      if (!completedHint) {

        completedHint = document.createElement('div');

        completedHint.className = 'geppetto-microquiz-completed-hint';

        wrap.appendChild(completedHint);

      }

      if (completed) {

        var scoreSummary = formatQuizScoreSummary(widgetId, manifest);

        completedHint.textContent = scoreSummary.main;

        completedHint.className = 'geppetto-microquiz-completed-hint' + (scoreSummary.passed ? '' : ' is-below-pass');

        completedHint.style.display = '';

      } else {

        completedHint.textContent = '';

        completedHint.style.display = 'none';

      }

      var hint = wrap.querySelector('.geppetto-microquiz-locked-hint');

      if (!hint) {

        hint = document.createElement('div');

        hint.className = 'geppetto-microquiz-locked-hint';

        wrap.appendChild(hint);

      }

      if (ckBlocked) {

        hint.textContent = ckLabel

          ? ('Conclua o checkpoint "' + ckLabel + '" para liberar o quiz.')

          : (requiresCk

            ? 'Conclua o checkpoint deste trecho para liberar o quiz.'

            : 'Conclua o checkpoint exigido antes de iniciar este quiz.');

      } else if (waitingServer) {

        hint.textContent = 'Verificando liberação do quiz…';

      } else if (attemptsExhausted) {

        hint.textContent = 'Você atingiu o limite de tentativas deste quiz.';

      } else {

        hint.textContent = '';

      }

    }

  }



  function bind() {

    document.addEventListener('click', function(ev) {

      var closeBtn = ev.target.closest('.geppetto-microquiz-close');

      if (closeBtn) {

        closeModal(closeBtn.closest('.geppetto-microquiz-modal'));

        return;

      }

      if (ev.target.classList && ev.target.classList.contains('geppetto-microquiz-modal')) {

        closeModal(ev.target);

        return;

      }

      var trigger = ev.target.closest('.geppetto-microquiz-trigger');

      if (!trigger || trigger.disabled) return;

      var modalId = trigger.getAttribute('data-modal-id');

      var widgetId = trigger.getAttribute('data-quiz-id');

      var wrap = trigger.closest('.geppetto-microquiz-wrap');

      var manifest = getManifestEntry(widgetId);

      if (isMoodleLive() && !quizStateLoaded) {

        ev.preventDefault();

        return;

      }

      if (isQuizCheckpointBlocked(widgetId, wrap, manifest)) {

        ev.preventDefault();

        refreshTriggerStates();

        return;

      }

      var modal = document.getElementById(modalId);

      if (!modal) return;

      openModal(modal, trigger, widgetId);

      startQuiz(widgetId, modal);

    });



    loadQuizStates().then(refreshTriggerStates);

    hydrateCkProgressFromServer().then(refreshTriggerStates);

    document.addEventListener('geppettoCheckpointDone', function() {

      refreshTriggerStates();

    });

    document.addEventListener('geppettoCheckpointSaved', function() {

      loadQuizStates().then(refreshTriggerStates);

    });

    setInterval(function() {

      refreshTriggerStates();

    }, 1500);

    window.addEventListener('message', function(event) {

      if (event.data && event.data.type === 'madriProgressData') {

        if (window.__geppettoCkProgress && typeof window.__geppettoCkProgress.mergeDone === 'function') {

          window.__geppettoCkProgress.mergeDone(event.data.doneArr);

        }

        loadQuizStates().then(refreshTriggerStates);

      }

      if (event.data && event.data.type === 'geppettoQuizStateRefresh') {

        loadQuizStates().then(refreshTriggerStates);

      }

    });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', bind);

  } else {

    bind();

  }

})();

</script>`;


